import * as React from 'react'
import QuestionnaireStatusView from './QuestionnaireStatusView'
import QuestionnaireCommentsView from './QuestionnaireCommentsView'
import QuestionnaireAddCommentsView from './QuestionnaireAddCommentsView'
import ScoreView from '../Score/ScoreView'
import CreditView from '../Credit/CreditView'
import ProductDataView from '../Product/ProductDetailsView'
import QuestionnaireUserHistoryItemsView from './QuestionnaireUserHistoryItemsView'
import QuestionnaireContentLinksForm from './QuestionnaireContentLinksForm'
import { observer } from 'mobx-react'
import DownloadDocument from './DownloadDocument'
// import GetExternalDataByPhoneForm from './GetExternalDataByPhoneForm'
import PassportPhotoView from './PassportPhotoView'
import { getCreditLimitByEmail, Questionnaire } from '../../../Model/Questionnaire'
import QuestionnaireDateInfoView from './QuestionnaireDateInfoView'
import PaymentsView from '../Payment/PaymentsView'
import { toJS } from 'mobx'
import DebtInfoView from '../TroubleEvent/DebtInfoView'
import { getFindQuestionnairesTable } from '../../../Model/QuestionnaireTableModel'
import QuestionnaireExternalDataView from './QuestionnaireExternalDataView'
import { getEventsFromQ } from '../../../Model/TroubleEventsTableSimpleItem'
import { getCreditConditionForm } from '../../../Model/CreditCondition'
import PaymentScheduleView from '../PaymentSchedule/PaymentScheduleView'
import { getPaymentSchedule } from '../../../Helpers/PaymentScheduleHelper'
import { PaymentScheduleEditLinkView } from '../PaymentSchedule/PaymentScheduleEditLinkView'
import QuestionnaireAssignView from './QuestionnaireAssignView'
import { getAgentInfoForm } from '../../../Model/AgentInfo'
import { getCourtDecisionForm } from '../../../Model/CourtDecision'
import { getMobileIMEIForm, MobileIMEIRequest } from '../../../Model/MobileIMEI'

export interface IQuestionnaireDetailsViewProps {
    questionnaire: Questionnaire
    className?: string
}

@observer
export default class QuestionnaireDetailsView
    extends React.Component<IQuestionnaireDetailsViewProps> {

    constructor(props: any) {
        super(props)
    }

    render() {
        const { questionnaire } = this.props

        if (!questionnaire) {
            return null
        }
        return (
            <div className={this.props.className}>
                <div className="detailsViewWrapper">
                    <QuestionnaireStatusView
                        className="col-12 blockStatus"
                        status={questionnaire.status}
                        inProgressByUserId={questionnaire.inProgressByUserId}
                        qId={questionnaire.id}
                        cancelReason={questionnaire.cancelReason}
                    />

                    <QuestionnaireAssignView
                        className="col-12 blockAssign"
                        status={questionnaire.status}
                        inProgressByUserId={questionnaire.inProgressByUserId}
                        qId={questionnaire.id}
                        history={questionnaire.questionnaireUserHistoryItems}
                    />

                    <PassportPhotoView pin={questionnaire.client.passport.pin} />

                    {getCourtDecisionForm(toJS(questionnaire))}

                    <CreditView
                        credit={questionnaire.credit}
                        className="col-12 blockCredit"
                    />
                    <hr />

                    <DebtInfoView credit={questionnaire.credit} />

                    <QuestionnaireExternalDataView
                        questionnaire={questionnaire}
                        className="col-12 blockExternalData"
                    />
                    <hr />

                    <QuestionnaireDateInfoView
                        questionnaire={questionnaire}
                        className="col-12 blockQMainInfo"
                    />
                    <hr />

                    <div className="rjsf download-document">
                        <div className="form-group field field-string">
                            <DownloadDocument
                                questionnaire={questionnaire}
                                className="block-download-document"
                            />
                        </div>
                    </div>
                    <hr />

                    {getCreditConditionForm(questionnaire)}

                    {getAgentInfoForm(questionnaire)}

                    {/* <QuestionnairePaymentsSchedule
                        className="col-12 blockPaymentsSchedule"
                        questionnaire={questionnaire}
                    /> */}

                    <PaymentScheduleView
                        className="col-12 block-payment-schedule-view"
                        scheduleArr={
                            getPaymentSchedule(questionnaire!.credit!.creditCondition!.paymentsScheduleJson)
                        }
                        prepaymentSum={questionnaire!.credit!.creditCondition!.prepaymentSum}
                    />
                    <PaymentScheduleEditLinkView questionnaire={questionnaire!} />
                    <hr />

                    <PaymentsView className="col-12" payments={toJS(questionnaire.credit.payments)} />

                    <ScoreView questionnaire={questionnaire} className="col-12 blockScore" />

                    {getCreditLimitByEmail()}

                    <hr />

                    <ProductDataView
                        questionnaire={questionnaire}
                        className="col-12 blockProductDetails"
                    />
                    <hr />
                    {getEventsFromQ()}
                    <hr />
                    {getFindQuestionnairesTable()}
                    <hr />

                    <QuestionnaireCommentsView
                        className="col-12"
                        questionnaire={questionnaire}
                    />
                    <QuestionnaireAddCommentsView
                        qId={questionnaire.id}
                        className="col-12 blockAddComment"
                    />
                    <hr />
                    <QuestionnaireUserHistoryItemsView
                        className="col-12"
                        questionnaireUserHistoryItems={questionnaire.questionnaireUserHistoryItems}
                    />
                    <hr />
                    <QuestionnaireContentLinksForm
                        className="col-12"
                        questionnaire={questionnaire}
                    />
                    <hr />
                    {
                        getMobileIMEIForm(
                            new MobileIMEIRequest(
                                questionnaire.id,
                                questionnaire.imeiList),
                            questionnaire.inProgressByUserId,
                            questionnaire.status
                        )
                    }
                    <hr />
                    {/* <GetExternalDataByPhoneForm/> */}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Questionnaire/QuestionnaireDetailsView.tsx